import SpriteSymbol from "../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "customer-onboarding",
  "use": "customer-onboarding-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"customer-onboarding\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M5 9a7 7 0 117 7 7 7 0 01-7-7m11.4 7.8A9 9 0 103 9a9 9 0 004.6 7.8A12.1 12.1 0 000 28v2h2v-2a10 10 0 0116.9-7.2l.1-.8h1.9a12 12 0 00-4.5-3.2M29 24h-3v-3a1 1 0 00-2 0v3h-3a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2\" data-name=\"Page-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol